<div class="rsm-shell">
  <rsm-topbar (logout)="logout()" [userName]="userName"></rsm-topbar>

  <div class="rsm-body">
    <rsm-sidenav [logoUrl]="logoUrl$ | async" [userName]="userName"></rsm-sidenav>

    <div class="rsm-content" [class.rsm-content--chat]="router.url.startsWith('/chat')">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
